import getInterleavedSearchExperimentStore from '../store/store';

export function clearInterleavedSearchResultContext(): void {
    getInterleavedSearchExperimentStore().currentInterleavedSearchResultContext = undefined;
}
